module.exports = {
  "country": "RS",
  "artist": "Bojana Stamenov",
  "song": "Beauty Never Lies",
  "year": "2015",
  "place": "10",
  "spotify": ""
};